import React from "react";
import { PageHeader } from "./PageHeader";
import YouTube from "react-youtube";

export const Movies = props => {
    const opts = {
        height: '390',
        width: '640',
        playerVars: {
            autoplay: 0
        }
    };
  return (
    <React.Fragment>
      <PageHeader title="Nagrania wykładów" />
      <div className="content-wrapper">
        <div className="main-content page-movie">
            <h5>Wykład Laureata Medalu M. Smoluchowskiego <br/> prof. Józef Spałek <br/> "Why strongly correlated quantum matter belongs to fundamental physics?"</h5>
             <YouTube
              containerClassName="movie"
              videoId="ArSpl60QFZw"
              opts={opts}
              />
              <hr/>
            <h5>Wykład Laureata Nagrody Mariana Smoluchowskiego - Emila Warburga <br/>prof. Peter Hänggi <br/>"The ring of Brownian motion: Past - Presence - Future Trends"</h5>
            <YouTube
                containerClassName="movie"
                videoId="hkCBYl6ZwQk"
                opts={opts}
            />
            <hr/>
            <h5>Wykład plenarny Laureata Nagrody Nobla w dziedzinie fizyki (2004) <br/> prof. Frank Wilczek <br/> "New Ideas in Axion Searches"</h5>
            <YouTube
                containerClassName="movie"
                videoId="_svGLLLQdPY"
                opts={opts}
            />
            <hr/>
            <h5>Wykład plenarny plenarny Laureata Nagrody Nobla w dziedzinie chemii (2011) <br/> prof. Dan Shechtman <br/>"Quasi-periodic crystals – a paradigm shift in crystallography"</h5>
            <YouTube
                containerClassName="movie"
                videoId="t5j8jNjZrP0"
                opts={opts}
            />
            <hr/>
            <h5>Debata "Granice Fizyki" <br/>z udziałem: <br/>Andrzej Białas, Iwo Białynicki-Birula, Włodzisław Duch, Michał Heller, Tadeusz Marek, Andrzej K. Wróblewski, Maciej Żylicz</h5>
            <YouTube
                containerClassName="movie"
                videoId="sOFt0FHeX20"
                opts={opts}
            />
            <hr/>



        </div>
      </div>
    </React.Fragment>
  );
};

Movies.propTypes = {};
